var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{staticClass:"error",attrs:{"block":""},on:{"click":_vm.eliminarLegajos}},[_vm._v(" Eliminar Liquidaciones ")])}
var staticRenderFns = []

export { render, staticRenderFns }